import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoMdArrowBack } from 'react-icons/io';
import upload from '../../assets/images/upload-icon.svg';
import { Form, Modal, Button } from 'react-bootstrap';
import 'cropperjs/dist/cropper.css';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import { createHeaderTemplate, editHeaderTemplate, getHeaderTemplateDetails } from '../../api/context/header';
import { submitImageTemplate } from '../../api/context/template';
import { TINY_MCE_API_KEY } from '../../utils/config.js'
import { Editor } from '@tinymce/tinymce-react';



const HeaderEmailCreate = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const editorRef = useRef(null);

    const fileInputRefs = useRef([]);
    const [imageSrcList, setImageSrcList] = useState([]);
    const [loading, setLoading] = useState(false);
    // Crop related state
    const [showImageUploadModal, setImageUploadModal] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [currentCropIndex, setCurrentCropIndex] = useState(null);


    const formik = useFormik({
        initialValues: {
            name: '',
            content: '',
            is_active: true,
        },
        // Add your validation schema here if needed
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                if (id) {
                    editHeaderTemplate(id, values)((response) => {
                        if (response && response?.data?.status_code === 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("Header Updated Successfully");
                            navigate("/header-email");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.message);
                        }
                    });
                } else {
                    if (values.image_base64) {
                        values.image_remove = false;
                    }
                    createHeaderTemplate(values)((response) => {
                        if (response && response?.data?.status_code === 201) {
                            setLoading(false);
                            resetForm();
                            toast.success("Header Created Successfully");
                            navigate("/header-email");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.error_message);
                        }
                    });
                }
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        },
    });





    const insertPlaceholder = (placeholder) => {

        if (editorRef.current) {
            const editor = editorRef.current;
            console.log(editor, 'editor');
            // // Insert the placeholder text with markers
            const placeholderText = `${placeholder}`;


            editor.insertContent(placeholderText);

            // Move the cursor inside the placeholder
            const rng = editor.selection.getRng(); // Get current range

            const startOffset = rng.startOffset - placeholderText.length + 1; // Calculate new start offset

            // Update the range to place the cursor inside the placeholder
            rng.setStart(rng.startContainer, startOffset);
            rng.setEnd(rng.startContainer, startOffset);

            editor.selection.setRng(rng); // Apply the updated range
            editor.focus(); // Ensure the editor is focused
        }
    };












    const handleTitleChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };

    const addImageForm = () => {
        setImageUploadModal(true)
    }

    console.log(imageSrcList, 'imageSrcList');

    const handleImageUpload = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const updatedImageSrcList = [...imageSrcList];
                updatedImageSrcList[index] = reader.result;
                setImageSrcList(updatedImageSrcList);
                setCurrentCropIndex(index);
                setCurrentImage(reader.result); // Store the uploaded image for cropping
                setImageUploadModal(true);
                submitImage(file.name, reader.result); // Submit image to the API
            };;
            reader.readAsDataURL(file);
        }
    };


    const submitImage = async (fileName, base64Data) => {
        const data = {
            file_name: fileName,
            image_base64: base64Data,
        };

        submitImageTemplate(data)((response) => {
            if (response && response?.data?.status_code === 201) {
                const imageUrl = response?.data?.data?.image_url;
                copyImageUrlToClipboard(imageUrl);
            } else {
            }
        });
    };


    const copyImageUrlToClipboard = (url) => {
        navigator.clipboard.writeText(url).then(() => {
            toast.success('Image URL copied to clipboard');
            handleModalClose()
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };




    const handleEditorChange = (content, editor) => {
        // console.log('Content was updated:', content);
        formik.setFieldValue('content', content);
    };







    const handleModalClose = () => {
        setImageUploadModal(false);
        setCurrentImage(null);
    };

    const getHeaderTemplate = async () => {
        setLoading(true);
        getHeaderTemplateDetails(id)(async (response) => {
            if (response?.data?.status_code === 200) {
                const header = response?.data?.data


                formik.setValues((prevState) =>
                ({
                    ...prevState,
                    id: id,
                    name: header?.name ? header?.name : '',
                    content: header?.content || '',
                }))

                setLoading(false)
            } else {
                setLoading(false)
            }
        })
    }

    useEffect(() => {
        if (id) {
            setLoading(true)
            getHeaderTemplate()
        }
    }, [id])

    console.log(formik.values, 'formik.values');
    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center">
                        <Link to='/header-email' className='back_btn_wrap'>
                            <IoMdArrowBack className='icon' />
                        </Link>
                        <h4 className="mb-sm-0">Add Header</h4>
                    </div>
                </div>
            </div>
            <div className='header_email_wrapper'>
                <Form onSubmit={formik.handleSubmit}>
                    <Form.Group className="mb-3" controlId="formBasic">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter title"
                            name='name'
                            value={formik.values.name}
                            onChange={handleTitleChange}
                            isValid={formik.touched.name && !formik.errors.name}
                            isInvalid={formik.touched.name && !!formik.errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>







                    <div>
                        <div className='btn_wrapper_email'>
                            <Button className='add_email_form' onClick={addImageForm}>Upload Image</Button>
                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('[]')}
                            >
                                Parameter
                            </button>
                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('^^')}
                            >
                                Button
                            </button>
                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('{}')}
                            >
                                Link
                            </button>
                        </div>
                        <Editor
                            apiKey={TINY_MCE_API_KEY}
                            onInit={(evt, editor) => (editorRef.current = editor)}
                            init={{
                                // Free plugins and configuration
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic backcolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                height: 500,
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
                                // Optionally retain the AI request configuration if required
                                ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                            }}
                            value={formik?.values?.content}
                            // initialValue=""
                            onEditorChange={handleEditorChange}
                        />
                        {/* <Editor
                                    apiKey={TINY_MCE_API_KEY}
                                    onInit={(evt, editor) => (editorRef.current = editor)}
                                    init={{
                                        plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss markdown',
                                        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                                        tinycomments_mode: 'embedded',
                                        tinycomments_author: 'Author name',
                                        mergetags_list: [
                                            { value: 'First.Name', title: 'First Name' },
                                            { value: 'Email', title: 'Email' },
                                        ],
                                        ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                                    }}
                                    initialValue=""
                                    onEditorChange={handleEditorChange}

                                /> */}
                    </div>


                    {/* Crop Modal */}
                    <Modal className='crop_image_wrapper' show={showImageUploadModal} onHide={handleModalClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Image</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className='fileUploader'>
                                <div className="fileContainer">
                                    {currentImage ? (
                                        <img src={currentImage} alt='Uploaded Image' className='uploadIcon img-fluid' />
                                    ) : (
                                        <img src={upload} alt='Upload Icon' className='uploadIcon' />
                                    )}
                                    <p>Max file size: 5mb, accepted: jpg|gif|png</p>
                                    <input
                                        type="file"
                                        accept=".jpg, .png"
                                        onChange={(event) => handleImageUpload(event, currentCropIndex)}
                                        style={{ display: 'none' }}
                                        ref={el => fileInputRefs.current = el}
                                    />
                                    <button
                                        type="button"
                                        className="chooseFileButton"
                                        onClick={() => fileInputRefs.current.click()}
                                    >
                                        Choose image
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='btn_wrapper_save'>
                                <Button className='cancel_form_data' variant="secondary" onClick={handleModalClose}>
                                    Cancel
                                </Button>
                                {/* <Button className='save_form_data' variant="primary" onClick={() => copyImageUrlToClipboard(currentImage)}>
                                    Copy Image URL
                                </Button> */}
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/* Save Form Data Button */}
                    <div className='btn_wrapper_bottom'>
                        {/* <Button className='add_email_form' onClick={togglePreview}>
                            Preview
                        </Button> */}
                        <Button className='cancel_btn_form' onClick={() => navigate(-1)}>Cancel</Button>
                        <Button className='save_form_data' type='submit' disabled={loading}>  {loading ? "Loading" : id ? "Update" : "Create"}</Button>
                    </div>
                </Form>


            </div>
        </div>
    );
};

export default HeaderEmailCreate;
